import React, { useRef } from 'react';

const CarouselProperties = ({ block, onUpdate }) => {
    const fileInputRef = useRef(null);

    const handleFileChange = (e) => {
        const files = Array.from(e.target.files);
        if (files.length > 0) {
            const newImagesPromises = files.map(file => {
                return new Promise((resolve) => {
                    const reader = new FileReader();
                    reader.onloadend = () => resolve(reader.result);
                    reader.readAsDataURL(file);
                });
            });

            Promise.all(newImagesPromises).then(newImageUrls => {
                const updatedImages = [...(block.content || []), ...newImageUrls];
                onUpdate(block.id, { content: updatedImages });
            });
        }
    };

    const handleDeleteImage = (indexToDelete) => {
        const newImages = (block.content || []).filter((_, index) => index !== indexToDelete);
        onUpdate(block.id, { content: newImages });
    };

    return (
        <div className="space-y-4">
            <label className="block text-sm font-medium">Images du Carrousel</label>
            <div className="grid grid-cols-3 gap-2">
                {(block.content || []).map((imgSrc, index) => (
                    <div key={index} className="relative">
                        <img src={imgSrc} alt={`Slide ${index}`} className="w-full h-16 object-cover rounded" />
                        <button onClick={() => handleDeleteImage(index)} className="absolute top-0 right-0 bg-red-500 text-white rounded-full p-0.5 text-xs leading-none w-4 h-4 flex items-center justify-center">×</button>
                    </div>
                ))}
            </div>
            <button onClick={() => fileInputRef.current.click()} className="w-full p-2 bg-white border rounded text-center">
                Ajouter des images
            </button>
            <input 
                type="file" 
                ref={fileInputRef}
                accept="image/*"
                multiple
                onChange={handleFileChange} 
                className="hidden" 
            />
             <div>
                <label className="flex items-center">
                    <input 
                        type="checkbox" 
                        checked={block.isFullWidth || false} 
                        onChange={(e) => onUpdate(block.id, { isFullWidth: e.target.checked })} 
                        className="h-4 w-4 text-indigo-600 border-gray-300 rounded"
                    />
                    <span className="ml-2 text-sm text-gray-700">Pleine largeur</span>
                </label>
            </div>
            <div className="pt-4 border-t">
                <label className="block text-sm font-medium">Marge haute ({block.paddingTop || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingTop || 0} onChange={(e) => onUpdate(block.id, { paddingTop: parseInt(e.target.value) })} className="w-full" />
            </div>
            <div>
                <label className="block text-sm font-medium">Marge basse ({block.paddingBottom || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingBottom || 0} onChange={(e) => onUpdate(block.id, { paddingBottom: parseInt(e.target.value) })} className="w-full" />
            </div>
             <div>
                <label className="block text-sm font-medium">Marges latérales ({block.paddingLeft || 0}px)</label>
                <input type="range" min="0" max="64" value={block.paddingLeft || 0} onChange={(e) => {
                    const value = parseInt(e.target.value);
                    onUpdate(block.id, { paddingLeft: value, paddingRight: value });
                }} className="w-full" />
            </div>
        </div>
    );
};

export default CarouselProperties;